"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCatalogDownloadUrl = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const get_catalog_query_1 = require("./get-catalog.query");
const client_utils_1 = require("../client.utils");
const hooks_1 = require("../../../hooks");
const localization_1 = require("../../../localization");
const useCatalogDownloadUrl = ({ catalogId }) => {
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [fetchCatalogSupplies, { loading }] = (0, react_2.useLazyQuery)(get_catalog_query_1.GET_CATALOG_SUPPLIES);
    const getCatalogDownloadUrl = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!catalogId) {
            addError(t({ key: 'CATALOG_NOT_FOUND' }));
            return;
        }
        try {
            const response = yield fetchCatalogSupplies({
                variables: { ids: [catalogId] },
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(response);
            const suppliesNode = (_f = (_e = (_d = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.catalogs) === null || _b === void 0 ? void 0 : _b.edges[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.supplies) === null || _e === void 0 ? void 0 : _e.edges[0]) === null || _f === void 0 ? void 0 : _f.node;
            const url = ((_h = (_g = suppliesNode === null || suppliesNode === void 0 ? void 0 : suppliesNode.destination) === null || _g === void 0 ? void 0 : _g.urls) === null || _h === void 0 ? void 0 : _h.read) || null;
            if (url) {
                window.open(url);
            }
            else {
                addError(t({ key: 'DOWNLOAD_URL_NOT_FOUND' }));
            }
        }
        catch (error) {
            addError(t({ key: 'CATALOG_DOWNLOAD_URL_FAIL' }));
        }
    }), [addError, catalogId, fetchCatalogSupplies, t]);
    return {
        getCatalogDownloadUrl,
        loading,
    };
};
exports.useCatalogDownloadUrl = useCatalogDownloadUrl;
exports.default = exports.useCatalogDownloadUrl;
